export default __webpack_public_path__ + "static/media/thumbnail.72b3031d.png";